module.exports = __webpack_public_path__ + "img/section_02.a0c8c2da.png";